// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentGuardianInfoModel {
    static getAttributeTypeMap() {
        return EnrollmentGuardianInfoModel.attributeTypeMap;
    }
}
EnrollmentGuardianInfoModel.discriminator = undefined;
EnrollmentGuardianInfoModel.additionalProperties = false;
EnrollmentGuardianInfoModel.attributeTypeMap = [
    {
        "name": "personId",
        "baseName": "personId",
        "type": "number"
    },
    {
        "name": "namePrefix",
        "baseName": "namePrefix",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "nameSuffix",
        "baseName": "nameSuffix",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "relationship",
        "baseName": "relationship",
        "type": "TCSRelationshipType"
    },
    {
        "name": "primaryPhoneNumber",
        "baseName": "primaryPhoneNumber",
        "type": "EnrollmentPhoneNumberModel"
    },
];
//# sourceMappingURL=enrollmentGuardianInfoModel.js.map